import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
// import header from './modules/header';
// import map from './modules/map';
// import massage from './modules/massage';
// import app from './modules/app';
// import settings from './modules/settings';
import user from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
  },
  getters,
});

export default store;
